import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-verification-detail-decline-modal',
  templateUrl: './verification-detail-decline-modal.component.html',
  styleUrls: ['./verification-detail-decline-modal.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatCard
  ]
})
export class VerificationDetailDeclineModalComponent {

  reason?: string;

  constructor(private dialogRef: MatDialogRef<VerificationDetailDeclineModalComponent>) { }

  onSendClick(): void {
    this.dialogRef.close(this.reason);
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }
}